import React from 'react';
import { Column } from 'react-table';
import { FormattedMessage } from 'react-intl';
import CustomSelect from '../../../../components/CustomSelect';
import { AutoSendReport } from '../../../../common/enums/AutoSendReport';
import { toPairs, pipe, map } from 'ramda';
import Checkbox from '../../../../components/Checkbox';
import { INotifications } from '../../../../common/models/user/INotifications';
import { IBindingCallback1, IBindingCallback2 } from '../../../../common/models/callback';
import { IFormattedMessage } from '../../../../common/models/common/IFormattedMessage';

export interface INotificationData {
  event: keyof INotifications;
  value: boolean | null | AutoSendReport;
}

export const getData = (notifications: INotifications) => [{
  event: 'autoSendReport',
  value: notifications.autoSendReport
}, {
  event: 'prospectAssigned',
  value: notifications.prospectAssigned
}, {
  event: 'candidateAssigned',
  value: notifications.candidateAssigned
}];

const frequencyOptions = pipe<
  Record<string, string>,
  [string, string][],
  { value: string; label: IFormattedMessage }[]
>(
  toPairs,
  map(([key, value]) => ({ value, label: { id: key, defaultMessage: value } }))
)(AutoSendReport);

export const getColumns = (
  onUpdateValue: IBindingCallback2<keyof INotifications, boolean>,
  onUpdateReferenceCheck: IBindingCallback1<AutoSendReport>
): Column[] => [
  {
    Header: () => <FormattedMessage id="notificationsPane.event" defaultMessage="Event" />,
    accessor: 'event',
    id: 'event',
    Cell: ({ cell: { value } }) => (
      <FormattedMessage id={value} defaultMessage={value} />
    )
  },
  {
    Header: () => <FormattedMessage id="notificationsPane.sendEmail" defaultMessage="Send me an email" />,
    accessor: 'value',
    id: 'value',
    Cell: ({ row: { original } }: any) => (
      <div className="table-center" style={{ maxWidth: '120px' }}>
        <Checkbox
          checked={Boolean(original.value)}
          onChange={({ target }) => onUpdateValue(original.event, target.checked)}
        />
      </div>
    )
  },
  {
    Header: () => <FormattedMessage id="notificationsPane.frequency" defaultMessage="Frequency" />,
    id: 'frequency',
    Cell: ({ row: { original } }: any) => (original.event === 'autoSendReport' && original.value
      ? (
        <div>
          <CustomSelect
            value={original.value}
            onChange={val => onUpdateReferenceCheck(val as AutoSendReport)}
            options={frequencyOptions}
          />
        </div>
      )
      : null
    )
  }
];
